/**
 * Vendors
 */
import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Config
 */
export const authList = {
  SMS: 1,
  GAUTH: 2,
};

export const codeFieldName = {
  1: 'sms_code',
  2: 'token',
};

export const sessionFieldName = {
  1: 'sms_session_id',
  2: null,
};

/**
 * Make request fields
 * @param {Number} type two factor verification type
 * @param {Number} code verification code
 * @param {Number} session session ID
 */
export const makeFields = (type, code, session) => {
  const result = {};

  if (codeFieldName[type]) {
    const field = codeFieldName[type];
    result[field] = code;
  }

  if (sessionFieldName[type]) {
    const field = sessionFieldName[type];
    result[field] = session;
  }

  return result;
};

/**
 * Render function for countdown lib
 * @see {@link https://github.com/ndresx/react-countdown}
 * @param {Object}
 */
export const countDownRender = ({ minutes, seconds, completed }) => {
  if (completed) {
    return <span>Срок действия истек</span>;
  } else {
    return (
      <span>
        <FormattedMessage id="notifications.sms.modal.timer" /> {('00' + minutes).slice(-2)}:
        {('00' + seconds).slice(-2)}
      </span>
    );
  }
};

/**
 * Get code input placeholder
 * @param {IntlShape} intl i18n function
 * @param {Number} session Session ID
 */
export const getPlaceholder = (intl, session) => {
  if (session) {
    let placeholder = intl.formatMessage({
      id: 'notifications.sms.modal.session',
      defaultMessage: 'Session №',
    });

    placeholder += session;

    return placeholder;
  }

  return '';
};
